import { Box, Typography } from '@mui/material';
import { MouseEventHandler, ReactNode } from 'react';

import { COLORS } from '@/styles/tokens/colors';

interface TypeaheadPopperFooterProps {
  children: ReactNode;
  onMouseDown?: MouseEventHandler<HTMLDivElement>;
}

export function TypeaheadPopperFooter({
  children,
  onMouseDown,
}: TypeaheadPopperFooterProps) {
  const isTextFooter = typeof children === 'string';

  return (
    <Box
      onMouseDown={onMouseDown}
      sx={{
        borderTop: `1px solid ${COLORS.GRAY[200]}`,
        bgcolor: isTextFooter ? COLORS.GRAY[50] : COLORS.PRIMITIVES.WHITE,
        borderBottomLeftRadius: isTextFooter ? 'inherit' : undefined,
        borderBottomRightRadius: isTextFooter ? 'inherit' : undefined,
        p: isTextFooter ? undefined : 1,
        px: isTextFooter ? 1.5 : undefined,
        py: isTextFooter ? 0.5 : undefined,
      }}
    >
      {isTextFooter ? (
        <Typography variant="body-xs">{children}</Typography>
      ) : (
        children
      )}
    </Box>
  );
}
